import { INDRAApiService } from '@ibe.services/api.indra.service';
import { BehaviorSubject } from 'rxjs/index';
import { DEFAULT_LANGUAGE, URL_LOCALES, URL_MARKET_TRANSLATIONS, MOCK_URL_CURRENCY, MOCK_STATUS, MOCK_URL_MARKET_LIST } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
var LANGUAGE_TAG = 'header.menu.language.';
var MARKET_ENTITY = 1;
// default market & language
export var DEFAULT_MARKET = 'PT';
var INDRALanguageMarketService = /** @class */ (function () {
    function INDRALanguageMarketService(api) {
        this.api = api;
        this._observableMarket = new BehaviorSubject(sessionStorage.getItem('market'));
        this._observableLanguage = new BehaviorSubject(sessionStorage.getItem('language'));
        this.isUnitedKingdomMarket = false;
    }
    Object.defineProperty(INDRALanguageMarketService.prototype, "market$", {
        get: function () {
            return this._observableMarket.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRALanguageMarketService.prototype, "language$", {
        get: function () {
            return this._observableLanguage.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    INDRALanguageMarketService.prototype.setMarket = function (market) {
        sessionStorage.setItem('market', market);
        this._observableMarket.next(market);
    };
    INDRALanguageMarketService.prototype.setLanguage = function (language) {
        sessionStorage.setItem('language', language);
        this._observableLanguage.next(language);
    };
    INDRALanguageMarketService.prototype.getMarkets = function () {
        if (MOCK_STATUS.MARKET_LIST) {
            return this.api.INDRA_get(MOCK_URL_MARKET_LIST);
        }
        else {
            return this.api.INDRA_get(URL_MARKET_TRANSLATIONS);
        }
    };
    INDRALanguageMarketService.prototype.getCurrency = function () {
        return this.api.INDRA_get(MOCK_URL_CURRENCY);
    };
    INDRALanguageMarketService.prototype.getLocales = function () {
        return this.api.INDRA_get(URL_LOCALES);
    };
    INDRALanguageMarketService.prototype.getLanguages = function (markets) {
        var translations = {};
        var _loop_1 = function (key) {
            var market = markets[key];
            market.marketTrans.forEach(function (translation) {
                var marketTranslations = translations[translation.language];
                if (!marketTranslations) {
                    translations[translation.language] = [];
                }
                translations[translation.language].push({
                    label: translation.translation,
                    code: market.marketCode.toLocaleLowerCase()
                });
            });
        };
        for (var key in markets) {
            _loop_1(key);
        }
        return translations;
    };
    INDRALanguageMarketService.prototype.getCountryList = function (markets, languages) {
        var countries = [];
        for (var key in markets) {
            var market = markets[key];
            if (market.marketCode === 'GLOBAL') {
                continue;
            }
            // let countryLanguage = sessionStorage.getItem('language');
            // if (!countryLanguage) countryLanguage = DEFAULT_LANGUAGE;
            var countryLanguage = "en";
            var country = {
                code: market.marketCode,
                image: this.getFlag(market.marketCode),
                country: this.getCountryName(languages, market.marketCode.toLocaleLowerCase(), countryLanguage),
                language: this.getLanguagesPerMarket(market)
            };
            countries.push(country);
        }
        countries.sort(function (a, b) {
            if (a.country < b.country)
                return -1;
            if (a.country > b.country)
                return 1;
            return 0;
        });
        return countries;
    };
    INDRALanguageMarketService.prototype.getCountryName = function (languages, selectedMarket, selectedLanguage) {
        // user ibeadminservice
        if (languages && languages[selectedLanguage]) {
            var translations = languages[selectedLanguage].filter(function (translation) { return translation.code === selectedMarket; });
            if (translations.length > 0)
                return translations[0].label;
            else {
                translations = languages[DEFAULT_LANGUAGE].filter(function (translation) { return translation.code === selectedMarket; });
                if (translations.length > 0)
                    return translations[0].label;
                else
                    return selectedMarket;
            }
        }
        return selectedMarket;
    };
    INDRALanguageMarketService.prototype.getLanguagesPerMarket = function (market) {
        var languages = [];
        market.locales.forEach(function (locale) {
            languages.push({
                label: LANGUAGE_TAG + locale,
                code: locale
            });
        });
        return languages;
    };
    INDRALanguageMarketService.prototype.getFlag = function (countryCode) {
        var code = countryCode.toLocaleLowerCase();
        switch (code) {
            case 'dz':
                return 'flags--flag-algeria';
            case 'ao':
                return 'flags--flag-angola';
            case 'ar':
                return 'flags--flag-argentina';
            case 'at':
                return 'flags--flag-austria';
            case 'be':
                return 'flags--flag-belgium';
            case 'ca':
                return 'flags--flag-canada';
            case 'cv':
                return 'flags--flag-cape_verde';
            case 'cl':
                return 'flags--flag-chile';
            case 'co':
                return 'flags--flag-colombia';
            case 'cz':
                return 'flags--flag-czech_republic';
            case 'do':
                return 'flags--flag-dominican-republic';
            case 'eg':
                return 'flags--flag-egypt';
            case 'ee':
                return 'flags--flag-estonia';
            case 'fi':
                return 'flags--flag-finland';
            case 'fr':
                return 'flags--flag-france';
            case 'de':
                return 'flags--flag-germany';
            case 'gh':
                return 'flags--flag-ghana';
            case 'gm':
                return 'flags--flag-gambia';
            case 'gr':
                return 'flags--flag-greece';
            case 'hu':
                return 'flags--flag-hungary';
            case 'ie':
                return 'flags--flag-ireland';
            case 'it':
                return 'flags--flag-italy';
            case 'lv':
                return 'flags--flag-latvia';
            case 'lt':
                return 'flags--flag-lithuania';
            case 'lu':
                return 'flags--flag-luxembourg';
            case 'ml':
                return 'flags--flag-mali';
            case 'mx':
                return 'flags--flag-mexico';
            case 'ma':
                return 'flags--flag-morocco';
            case 'mz':
                return 'flags--flag-mozambique';
            case 'nl':
                return 'flags--flag-netherlands';
            case 'pa':
                return 'flags--flag-panama';
            case 'pl':
                return 'flags--flag-poland';
            case 'ro':
                return 'flags--flag-romania';
            case 'ru':
                return 'flags--flag-russia';
            case 'sn':
                return 'flags--flag-senegal';
            case 'rs':
                return 'flags--flag-serbia';
            case 'sk':
                return 'flags--flag-slovakia';
            case 'za':
                return 'flags--flag-south_africa';
            case 'se':
                return 'flags--flag-sweden';
            case 'ch':
                return 'flags--flag-switzerland';
            case 'gb':
                return 'flags--flag-uk';
            case 'uy':
                return 'flags--flag-uruguay';
            case 'us':
                return 'flags--flag-usa';
            case 'es':
                return 'flags--flag-spain';
            case 'br':
                return 'flags--flag-brazil';
            case 'pt':
                return 'flags--flag-portugal';
            case 'dk':
                return 'flags--flag-denmark';
            case 'hk':
                return 'flags--flag-hong_kong';
            case 'hr':
                return 'flags--flag-croatia';
            case 'ua':
                return 'flags--flag-ukraine';
            case 'no':
                return 'flags--flag-norway';
            case 'au':
                return 'flags--flag-australia';
            case 'md':
                return 'flags--flag-moldova';
            case 'me':
                return 'flags--flag-montenegro';
            case 'tg':
                return 'flags--flag-togo';
            case 'tr':
                return 'flags--flag-turkey';
            case 've':
                return 'flags--flag-south_america';
            case 'ba':
                return 'flags--flag-bosnia-and-herzegovina';
            case 'cn':
                return 'flags--flag-china';
            case 'gw':
                return 'flags--flag-guinea-bissau';
            case 'gn':
                return 'flags--flag-guinea';
            case 'ci':
                return 'flags--flag-ivory-coast';
            case 'st':
                return 'flags--flag-sao_tome_and_principe';
            case 'il':
                return 'flags--flag-israel';
            default:
                return '';
        }
    };
    INDRALanguageMarketService.prototype.loadDefaultLanguageMarket = function () {
        var appDefaultMarket = DEFAULT_MARKET.toLowerCase() + "-" + DEFAULT_MARKET;
        var defaultLang = window.navigator.languages;
        if (defaultLang.length) {
            var filteredDefaultLang = defaultLang.filter(function (item) { return item.includes("-"); });
            appDefaultMarket = filteredDefaultLang.length > 0 ? filteredDefaultLang[0] : appDefaultMarket;
        }
        return appDefaultMarket.split("-");
    };
    INDRALanguageMarketService.ngInjectableDef = i0.defineInjectable({ factory: function INDRALanguageMarketService_Factory() { return new INDRALanguageMarketService(i0.inject(i1.INDRAApiService)); }, token: INDRALanguageMarketService, providedIn: "root" });
    return INDRALanguageMarketService;
}());
export { INDRALanguageMarketService };
